import React from 'react';
import PropTypes from 'prop-types';

const GeneralStyledComponent = ({ className, component: Component, ...props }) => (
    <Component className={className} {...props} />
);

GeneralStyledComponent.propTypes = {
    className: PropTypes.string,
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
};

GeneralStyledComponent.defaultProps = {
    className: '',
};

export default GeneralStyledComponent;
